<template>
  <div id="EnergyOrganize">
    <div class="title clearfix">
      <div class="f-l" id="root" @click="reset"><img :src="homeUrl">默认组</div>
      <div class="f-r" v-show="!$store.state.isLook&&treeObj.type==1">
        <img ref="add" title="新建" v-show="treeObj.level<2" :src="add" @mouseover="imgHover('add')"
          @mouseout="disHover('add')" @click="popup('addShow')">
        <img :src="add3" title="新建" v-show="treeObj.level>1">
        <img ref="edit" title="编辑" v-show="treeObj.level<3&&treeObj.level!=0" :src="edit" @mouseover="imgHover('edit')"
          @mouseout="disHover('edit')" @click="popup('editShow')">
        <img :src="edit3" title="编辑" v-show="treeObj.level>2">
        <img ref="del" title="删除" v-show="treeObj.level<3&&treeObj.level!=0" style="width: 18px;" :src="del" @mouseover="imgHover('del')"
          @mouseout="disHover('del')" @click="popup('delShow')">
        <img style="width: 18px;" title="删除" :src="del3" v-show="treeObj.level>2">
      </div>
      <div class="f-r not-allowed" v-show="$store.state.isLook || treeObj.type==2">
        <img :src="add3" title="新建">
        <img :src="edit3" title="编辑">
        <img style="width: 18px;" title="删除" :src="del3">
      </div>
    </div>
    <!-- 组织树  -->
    <div class="tree">
      <el-tree ref="tree" :indent='0' :expand-on-click-node="false" :data="treeData" :check-on-click-node="false"
        node-key="key" :props="defaultProps" @node-click="nodeClick" :default-expand-all="true">
        <span class="custom-tree-node" slot-scope="{ node, data }" :ref="setRef(data)" :class="{'m-l-2':data.type==1}">
          <i><img :src="meter" class="tree-icon" v-if="data.type == 2"></i>
          <span :class="generateClassName(data.id)">{{ node.label }}</span>
        </span>
      </el-tree>
    </div>
    <div class="popup">
      <!-- 添加 -->
      <div class="popup-content" v-show="addShow">
        <div class="popup-title m-b-22">
          新建组织<i class="el-icon-circle-close close" @click="close('addShow')"></i>
        </div>
        <el-form :model='ruleForm' :rules="rules" ref="addForm" class="clearfix">
          <div class="popup-lab">
            <el-form-item prop="name" label="组名称：" autocomplete="off" class="no-title">
              <i><img :src="notes" title="组名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
              <el-input v-model="ruleForm.name" maxlength="32" placeholder="请输入组名称"></el-input>
            </el-form-item>
            <el-form-item prop="parentId" label="上级组：" autocomplete="off" class="no-title">
              <el-select v-model="ruleForm.parentId" placeholder="请选择" class="type-select">
                <el-option :key="0" label="默认组" :value="0"></el-option>
                <el-option v-for="item in treeData" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="type" label="组类型：" autocomplete="off" class="no-title">
              <el-select v-model="ruleForm.type" placeholder="请选择" class="type-select">
                <el-option v-for="item in typeArr" :key="item.id" :disabled="item.id>1" :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div class="btn-box">
          <el-button type="primary" @click='clickAdd'>确定</el-button>
          <el-button @click="close('addShow')">取消</el-button>
        </div>
      </div>
      <div class="popup-content" v-show="editShow">
        <div class="popup-title m-b-22">
          修改组织<i class="el-icon-circle-close close" @click="close('editShow')"></i>
        </div>
        <el-form :model='ruleForm' :rules="rules" ref="editForm" class="clearfix">
          <div class="popup-lab">
            <el-form-item prop="name" label="组名称：" autocomplete="off" class="no-title">
              <i><img :src="notes" title="组名称支持中文、英文字母、数字和下划线，由1~32个字符构成" class="notes"></i>
              <el-input v-model="ruleForm.name" maxlength="32" placeholder="请输入组名称"></el-input>
            </el-form-item>
            <el-form-item prop="parentId" label="上级组：" autocomplete="off" class="no-title">
              <el-select v-model="ruleForm.parentId" placeholder="请选择" class="type-select">
                <el-option :key="0" label="默认组" :value="0"></el-option>
                <el-option v-for="item in treeData" :key="item.id" :label="item.name" :value="item.id" :disabled="item.id==treeObj.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="type" label="组类型：" autocomplete="off" class="no-title">
              <el-select v-model="ruleForm.type" placeholder="请选择" class="type-select">
                <el-option v-for="item in typeArr" :key="item.id" :disabled="item.id>1" :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div class="btn-box">
          <el-button type="primary" @click='clickEdit'>确定</el-button>
          <el-button @click="close('editShow')">取消</el-button>
        </div>
      </div>
      <!-- 删除组织 -->
      <div class="popup-content" v-show='delShow'>
          <div class="popup-title m-b-22">
              删除组织<i class="el-icon-circle-close close" @click="close('delShow')" id="closeDelOr"></i>
          </div>
          <div class="popup-lab">
              <p>组织删除后不可恢复，是否继续？</p>
          </div>
        <div class="btn-box">
          <el-button type="primary" @click='yes'>确定</el-button>
          <el-button @click="close('delShow')">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        homeUrl: null,
        add: require('@/assets/image/organize/add.png'),
        del: require('@/assets/image/organize/delete.png'),
        add2: require('@/assets/image/organize/add2.png'),
        del2: require('@/assets/image/organize/delete2.png'),
        edit: require('@/assets/image/organize/edit.png'),
        edit2: require('@/assets/image/organize/edit2.png'),
        add3: require('@/assets/image/organize/add3.png'),
        del3: require('@/assets/image/organize/delete3.png'),
        edit3: require('@/assets/image/organize/edit3.png'),
        add4: require('@/assets/image/organize/add4.png'),
        del4: require('@/assets/image/organize/delete4.png'),
        edit4: require('@/assets/image/organize/edit4.png'),
        area: require('@/assets/image/company/jf.png'),
        meter: require('@/assets/image/company/meter.png'),
        notes: require('@/assets/image/organize/notes.png'),
        addShow: false,
        editShow: false,
        delShow: false,
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        typeArr: [{
            name: '电',
            id: 1
          },
          {
            name: '水',
            id: 2
          },
          {
            name: '气',
            id: 3
          },
          {
            name: '热',
            id: 4
          }
        ],
        treeObj: {},
        ruleForm: {
          name: null,
          parentId: null,
          type: 1,
        },
        rules: {
          name: [{
            message: '请输入组名称',
            required: true,
            trigger: 'blur'
          }],
          parentId: [{
            message: '请输入上级组',
            required: true,
            trigger: 'blur'
          }],
          type: [{
            message: '请选择类型',
            required: true,
            trigger: 'blur'
          }],
        }
      }
    },
    props: {
      treeData: {
        type: Array,
        default: () => {
          return []
        },
      },
      type: {
        type: Number,
        default: 1   //1 不带设备  2 带设备
      },
      treeType: {
        type: Number,
        default: 1   //1电，２水，３气，４热
      },
    },
    created() {
      this.homeUrl = require("@/assets/image/organize/xinweiwo" + this.cssType + ".png")
      this.$store.state.mask=false
    },
    methods: {
      yes(){
        this.get('/EnergyGroup/remove',{companyId:this.$store.state.companyId,id:this.treeObj.id}).then(res=>{
          if(res.success){
            let url = ''
            if(this.type == 1){
              url = '/EnergyGroup/getTree'
            }else{
              url = '/EnergyGroup/getTreeWithDevice'
            }
            this.get(url,{companyId:this.$store.state.companyId,type:this.treeType}).then(r=>{
              if(r.success){
                this.$emit('setTree',r.result)
              }else{
                this.$message({
                  message:`刷新组织失败：${r.message}`,
                  type:'warning'
                })
              }
            })
            this.reset()
            this.close('delShow')
          }else{
            this.$message({
              message:`删除失败：${res.message}`,
              type:'warning'
            })
          }
        })
      },
      reset(){
        this.treeObj = {id:0,name:'默认组',level:0,type:1}
        this.$emit('changeNode', this.treeObj)
      },
      // 点击节点
      nodeClick(obj, node, my) {
        this.treeObj = node.data
        this.treeObj.level = node.level
        this.$emit('changeNode', this.treeObj)
      },

      // 动态渲染树节点时设置id
      generateClassName(index) {
        return `item-${index}`
      },
      setRef(obj) {
        if (obj) {
          obj.key = 'node_' + obj.id + '_' + obj.type
          return 'node_' + obj.id + '_' + obj.type
        }
      },
      close(key) {
        this[key] = false;
        this.$store.state.mask = false
      },
      popup(key) {
        if(key =='editShow'){
          this.ruleForm = this.clone(this.treeObj)
        }else{
          this.ruleForm = this.$options.data().ruleForm
          this.ruleForm.parentId = this.treeObj.id
        }
        this[key] = true;
        this.$store.state.mask = true
      },
      // 图标hover
      imgHover(id) {
        if (this.cssType == 0) {
          if (id == "add") {
            this.$refs.add.src = this.add2
          } else if (id == "edit") {
            this.$refs.edit.src = this.edit2
          } else {
            this.$refs.del.src = this.del2
          }
        } else if (this.cssType == 1) {
          if (id == "add") {
            this.$refs.add.src = this.add4
          } else if (id == "edit") {
            this.$refs.edit.src = this.edit4
          } else {
            this.$refs.del.src = this.del4
          }
        }
      },
      disHover(id) {
        if (id == "add") {
          this.$refs.add.src = this.add
        } else if (id == "edit") {
          this.$refs.edit.src = this.edit
        } else {
          this.$refs.del.src = this.del
        }
      },
      // 创建
      clickAdd(){
        this.$refs.addForm.validate((valid) => {
            if (valid) {
              let data ={
                companyId:this.$store.state.companyId,
                parentId:this.ruleForm.parentId,
                name:this.ruleForm.name,
                type:this.ruleForm.type
              }
                this.post('/EnergyGroup/create',data).then(res=>{
                    if(res.success){
                      let id = res.result
                      this.get('/EnergyGroup/get',{id:id}).then( r => {
                        this.$store.state.mask=false
                        this.addShow=false
                        if(r.success){
                          let obj = r.result
                          if(data.parentId == 0){
                            obj.children=[]
                            this.treeData.push(obj)
                          }else{
                            let parent = this.treeData.filter(item => item.id==data.parentId)[0]
                            parent.children.push(obj)
                          }
                        }else{
                          if(data.parentId==0){
                            data.id = id
                            data.children=[]
                            this.treeData.push(obj)
                          }else{
                            let parent = this.treeData.filter(item => item.id==data.parentId)[0]
                            data.id = id
                            parent.children.push(data)
                          }
                        }
                      })
                    }else{
                        this.$message({
                            message:`创建失败：${res.message}`,
                            type:'warning'
                        })
                    }
                })
            }
        })
      },
      // 编辑
      clickEdit(){
        this.$refs.editForm.validate((valid) => {
            if (valid) {
              let data ={
                id:this.ruleForm.id,
                companyId:this.$store.state.companyId,
                parentId:this.ruleForm.parentId,
                name:this.ruleForm.name,
                type:this.ruleForm.type
              }
              this.post('/EnergyGroup/update',data).then(res=>{
                  if(res.success){
                    this.$store.state.mask=false
                    this.editShow=false
                    // 未修改上级组
                    if(data.parentId==0||this.ruleForm.level==1){
                      let obj = this.treeData.filter(item => item.id==data.id)[0]
                      obj.name = data.name
                      obj.type = data.type
                      return
                    }
                    if(this.treeObj.parentId == data.parentId){
                      let newParent = this.treeData.filter(item => item.id==data.parentId)[0]
                      for(let item of newParent.children){
                        if(item.id == data.id){
                          item.name = data.name
                          item.type = data.type
                        }
                      }
                    }else{
                        let oldParent = this.treeData.filter(item => item.id==this.treeObj.parentId)[0]
                        let newParent = this.treeData.filter(item => item.id==data.parentId)[0]
                        for(let i in oldParent.children){
                          if(oldParent.children[i].id == data.id){
                            oldParent.children.splice(i,1)
                          }
                        }
                        newParent.children.push(this.ruleForm)
                    }

                  }else{
                      this.$message({
                          message:`编辑失败：${res.message}`,
                          type:'warning'
                      })
                  }
              })
            }
        })
      },
    },
    watch: {
      treeData(){
        if (!this.treeObj.id || this.treeData.length != 0) {
          this.treeObj = {id:0,name:'默认组',level:0,type:1}
          this.$emit('changeNode', this.treeObj)
        }
      },
    }
  }
</script>

<style scoped>
  #EnergyOrganize {
    margin: 20px 16px;
    width: 297px;
    padding: 24px;
    padding-right: 10px;
    box-sizing: border-box;
    background-color: #fff;
    text-align: left;
    position: absolute;
    bottom: 0;
    top: 0;
    min-height: 817px;
  }

  #EnergyOrganize .title {
    font-size: 16px;
  }

  .title>div:first-child {
    cursor: pointer
  }

  .type-select {
    width: 100% !important;
    line-height: 34px !important;
  }

  #EnergyOrganize .title img {
    position: relative;
    top: 2px;
    margin-right: 10px;
    cursor: pointer;
    width: 20px;
  }

  #EnergyOrganize .title img:first-child {
    margin-right: 10px;
  }

  .popup>div {
    position: fixed;
    top: 10%;
    left: 50%;
    padding: 0 28px;
    box-sizing: border-box;
    margin-left: 255px;
    width: 578px;
    background-color: #fff;
    z-index: 9999;
    padding-bottom: 48px;
  }

  .popup-title {
    font-size: 16px;
    line-height: 64px;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 22px;
    text-align: left;
  }

  i .notes {
    position: relative;
    top: 5px;
  }

  i.close {
    font-size: 20px;
    float: right;
    margin-top: 24px;
  }

  .popup-del .popup-title {
    margin-bottom: 12px;
  }

  .popup-lab {
    font-size: 14px;
    line-height: 30px;
    margin-bottom: 18px;
  }

  .popup-btn-box {
    text-align: center;
    margin-top: 30px;
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 38px;
  }

  .popup-btn-box .el-button {
    padding: 0 34px !important;
    line-height: 34px !important;
    margin: 0 20px;
  }

  .btn-box {
    text-align: center;
    margin-top: 30px;
  }

  .btn-box .el-button {
    padding: 0 34px !important;
    line-height: 34px !important;
    margin: 0 16px;
  }

  .not-allowed,.not-allowed img {
    cursor: not-allowed;
  }

  .m-b-22 {
    margin-bottom: 22px !important;
  }
</style>
<style type="text/css">
  #EnergyOrganize .popup .el-form-item {
    width: 100% !important;
    margin-bottom: 11px !important;
  }

  #EnergyOrganize .popup .el-form .el-input__inner {
    width: 100% !important;
    height: 34px !important;
    line-height: 34px !important;
  }

  #EnergyOrganize .popup .el-input__icon {
    line-height: 34px !important;
  }

  #EnergyOrganize .tree .is-current>.el-tree-node__content {
    background-color: #dfdfdf !important;
  }

  /* 修改ele-ui 默认样式 */
  #EnergyOrganize .tree .el-tree-node__content .custom-tree-node {
    font-size: 14px !important;
    margin-left: 10px;
    position: relative;
    justify-content: stretch !important;
  }

  #EnergyOrganize .tree .el-tree-node__children .custom-tree-node {
    font-size: 14px !important;
    padding-right: 10px;
  }

  #EnergyOrganize .el-tree-node>.el-tree-node__children {
    overflow: unset !important;
  }

  #EnergyOrganize .tree .el-tree>.el-tree-node:after {
    border-top: none;
  }

  #EnergyOrganize .tree .el-tree-node {
    position: relative;
    padding-left: 16px;
  }

  #EnergyOrganize .tree .el-tree-node__content {
    background: #fff;
  }

  /* //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉 */
  #EnergyOrganize .tree .el-tree-node__expand-icon.is-leaf {
    display: none;
  }

  #EnergyOrganize .tree .el-tree-node__children {
    padding-left: 16px;
  }

  #EnergyOrganize .tree .el-tree-node :last-child:before {
    height: 18px;
  }

  #EnergyOrganize .tree .el-tree>.el-tree-node:before {
    border-left: none;
  }

  #EnergyOrganize .tree .el-tree>.el-tree-node:after {
    border-top: none;
  }

  #EnergyOrganize .tree .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  #EnergyOrganize .tree .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  #EnergyOrganize .tree .el-tree-node:before {
    border-left: 1px dashed #dedede;
    bottom: 0px;
    height: 100%;
    top: -7px;
    width: 1px;
  }

  #EnergyOrganize .tree .el-tree-node:after {
    border-top: 1px dashed #dedede;
    height: 20px;
    top: 12px;
    width: 24px;
  }

  #EnergyOrganize .el-input__inner {
    color: #252525;
  }

  #EnergyOrganize .dashed .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  #EnergyOrganize .dashed .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }

  #EnergyOrganize .dashed .el-tree-node:before {
    border-left: 1px dashed #dedede;
    bottom: 0px;
    height: 100%;
    top: -7px;
    width: 1px;
  }

  #EnergyOrganize .dashed .el-tree-node:after {
    border-top: 1px dashed #dedede;
    height: 20px;
    top: 12px;
    width: 24px;
  }

  #EnergyOrganize .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }

  #EnergyOrganize .tree {
    overflow: auto;
    position: absolute;
    top: 60px;
    bottom: 0;
    left: 30px;
    right: 0;
  }
  #EnergyOrganize .m-l-2{
    margin-left: 2px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/PublicAssembly/EnergyOrganize.vue